import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { STATS_PATH } from '../../core/constants';
import { buildQueryString, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getSalesByPodAction = createAsyncThunk(
    'stats/getSalesByPodAction',
    async (queryParams, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ STATS_PATH }/by-pod${ buildQueryString(queryParams) }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getSalesByPodSlice = createSlice({
    name: 'getSalesByPodSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getSalesByPodAction.pending, () => STATE__API__STARTED);
        builder.addCase(getSalesByPodAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getSalesByPodAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getSalesByPodState = (state) => state.stats.getSalesByPod;
export default getSalesByPodSlice.reducer;
